<template>
<div class="template visitorsDistribution">
  <div class="itemCon">
    <ul>
      <li>
        <span class="width">{{$t('im.visitorsDistribution.prioritySet')}}：</span>
        <div class="rightCon">
          <div class="item">
            <el-form :inline="true">
              <el-form-item class="inputCon">
                <el-input v-model="timeTxt"></el-input>
              </el-form-item>
              <el-form-item>
                <el-select v-model="timeType">
                  <el-option
                    v-for="item in timeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <p v-html="$t('im.visitorsDistribution.priorityCon')"></p>
          </div>
          <div class="item"><p>{{$t('im.visitorsDistribution.priorityExplain')}}</p></div>
        </div>
      </li>
      <li>
        <span class="width">{{$t('im.visitorsDistribution.allocationSet')}}：</span>
        <div class="rightCon">
          <el-form>
            <el-form-item>
              <el-radio v-model="radioTxt" label="1">{{$t('im.visitorsDistribution.allocationType1')}}</el-radio>
              <p></p>
            </el-form-item>
            <el-form-item>
              <el-radio v-model="radioTxt" label="0">{{$t('im.visitorsDistribution.allocationType0')}}</el-radio>
            </el-form-item>
            <el-form-item>
              <el-radio v-model="radioTxt" label="2">{{$t('im.visitorsDistribution.allocationType2')}}</el-radio>
            </el-form-item>
          </el-form>
        </div>
      </li>
    </ul>
  </div>
  <el-form class="dv_left">
    <el-form-item>
      <el-button type="primary" size="small" @click="editRule">{{$t('im.bt.save')}}</el-button>
    </el-form-item>
  </el-form>
  <el-table border :data="tableList" tooltip-effect="dark" style="width: 100%">
    <el-table-column :prop="itemTabNav.id" :label="itemTabNav.name" v-for="itemTabNav in tableNav" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column :label="$t('im.bt.operator')">
      <template slot-scope="scope">
        <el-button size="mini" @click="editDistribution(scope.row)">{{$t('im.bt.update')}}</el-button>
        <el-button size="mini" type="danger" @click="delDistribution(scope.row)">{{$t('im.bt.delete')}}</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div class="flexEnd" v-if="totalNum>0">
    <el-pagination
      background
      @size-change="pageSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-sizes="[8,16, 24, 32, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum">
    </el-pagination>
  </div>
  <el-dialog :title="$t('im.visitorsDistribution.editChatRelated')" :visible.sync="isToOftenPop">
    <div class="dv_list">
      <ul>
        <li><em>{{$t('im.visitorsDistribution.chatId')}}：</em><p>{{chatRelated.id}}</p></li>
        <li><em>{{$t('im.visitorsDistribution.displayName')}}：</em><p>{{chatRelated.displayName}}</p></li>
        <li><em>{{$t('im.visitorsDistribution.rolesStr')}}：</em><p>{{chatRelated.rolesStr}}</p></li>
        <li><em>{{$t('im.visitorsDistribution.companyName')}}：</em><p>{{chatRelated.companyName}}</p></li>
        <li>
          <em>{{$t('im.visitorsDistribution.relatedBusiness')}}：</em>
          <el-checkbox-group v-model="businessGroupIDs">
            <el-checkbox v-for="business in businessGroupData" :label="business.id">{{business.name}}</el-checkbox>
          </el-checkbox-group>
        </li>
        <li>
          <em>{{$t('im.common.locale')}}：</em>
          <el-checkbox-group v-model="langIds">
            <el-checkbox v-for="lang in localeList" :label="lang.id">{{lang.name}}</el-checkbox>
          </el-checkbox-group>
        </li>
        <li>
          <em>{{$t('im.visitorsDistribution.upperLimit')}}：</em>
          <el-input v-model="numTxt"></el-input>
        </li>
      </ul>
    </div>
    <div class="flexCenter">
      <el-button type="primary" @click="saveDistribution">{{$t('im.bt.definite')}}</el-button>
      <el-button @click="isToOftenPop=false">{{$t('im.bt.cancel')}}</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
  require('@/styles/IM/template.css')
  require('@/styles/IM/visitorsDistribution.css')
  import apiDeployManagement from '@/api/im/deployManagement'
  import Util from '@/utils/IM/tradeDataUtil'
  import { localRead } from '@/utils/tools'
  export default {
    name: 'visitorsDistribution',
    data(){
      return{
        util: Util,
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),  //用户信息
        timeTxt: '',//分配分钟数
        timeList: [
          {
            id: '0',
            name: window.$t('im.visitorsDistribution.minute')
          }, {
            id: '1',
            name: window.$t('im.visitorsDistribution.second')
          }, {
            id: '2',
            name: window.$t('im.visitorsDistribution.hour')
          }
        ],/*时间类型*/
        timeType: '0',/*默认时间类型*/
        radioTxt: '0',//分配方式类型
        totalNum: 0,  //当前资源条数
        currentPage: 1,  //当前页数
        pageSize:8, //当前页条数数
        tableList: [],  //当前资源列表
        tableNav: [
          { name: window.$t('im.visitorsDistribution.id'), id: 'id' },
          { name: window.$t('im.visitorsDistribution.userName'), id: 'userName' },
          { name: window.$t('im.visitorsDistribution.displayName'), id: 'displayName' },
          { name: window.$t('im.visitorsDistribution.rolesStr'), id: 'rolesStr' },
          { name: window.$t('im.visitorsDistribution.companyName'), id: 'companyName' },
          { name: window.$t('im.visitorsDistribution.relatedBusiness'), id: 'bizCodeName' },
          { name: window.$t('im.visitorsDistribution.upperLimit'), id: 'top' }
        ],  //当前资源列表头部
        isToOftenPop: false,//弹窗是否显示
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdCompany,  //业务编码列表
        businessGroupIDs: '',//关联业务编码列表
        localeList: [],//语言列表
        langIds: [],  //语言的ID列表
        chatRelated: [],//客服关联不可修改部分
        numTxt: '',//接待上线
        ruleType: '',//规则0：新增，1：编辑
        ruleID: '',//当前规则ID
      }
    },
    methods:{
      /*初始化公司语言*/
      initLanguage() {
        let data = { companyId: this.userInfo.companyId }, language, name, langData = []
        apiDeployManagement.getCompanyLanguage(data).then(res => {
          if (res.code == 0) {
            if (res.result.length > 0) {
              if (res.result.indexOf(',') > -1) {
                language = res.result.split(',')
              } else {
                language = [res.result]
              }
            }
            for (let i in language) {
              if (language[i] == 'cn'||language[i] == 'zh_CN') {
                name = '简体中文'
              } else if (language[i] == 'en'||language[i] == 'en_US') {
                name = 'English'
              } else if (language[i] == 'vn'||language[i] == 'vi_VN') name = 'Tiếng Việt'
              langData.push({ 'id': language[i], 'name': name })
            }
            this.localeList = langData
          }
        })
      },
      /*获取数据*/
      getUserList(data){
        apiDeployManagement.userList(data).then(res => {
          if (res.code == 0) {
            if (res.result.list) {
              this.totalNum = res.result.total
              let newData = JSON.parse(JSON.stringify(res.result.list))
              for (const i in newData) {
                let bizCodeData = []
                if (newData[i].businessId.length > 0) {
                  for (const j in newData[i].businessId) {
                    bizCodeData.push(newData[i].businessId[j].name)
                  }
                  newData[i].bizCodeName = bizCodeData.join(',')
                } else {
                  newData[i].bizCodeName = ''
                }
              }
              this.tableList = newData
            } else {
              this.tableList = []
              this.totalNum = 0
            }
          }
        })
      },
      /*初始化数据*/
      initUserList() {
        let data = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        }
        this.getUserList(data)
      },
      /*切换分页条数*/
      pageSizeChange(val) {
        this.pageSize = val
        let data = {
          pageNum: this.currentPage,
          pageSize: val
        }
        this.getUserList(data)
      },
      /*切换当前页*/
      currentChange(val) {
        this.currentPage = val
        let data = {
          pageNum: val,
          pageSize: this.pageSize
        }
        this.getUserList(data)
      },
      /*修改当前*/
      editDistribution(data) {
        this.isToOftenPop = true
        this.chatRelated = data
        this.numTxt = data.top
        let bizCodeData = [],langData;
        if (data.businessId.length > 0) {
          for (const i in data.businessId) {
            bizCodeData.push(data.businessId[i].id)
          }
          this.businessGroupIDs = bizCodeData
        } else {
          this.businessGroupIDs = []
        }
        if (data.language) {
          if (data.language.length > 0) {
            if (data.language.indexOf(',') > -1) {
              langData = data.language.split(',')
            } else {
              langData = [data.language]
            }
            this.langIds = langData
          }
        } else {
          this.langIds = []
        }
      },
      /*删除当前*/
      delDistribution(row) {
        let data = { id: row.id }
        apiDeployManagement.delUser(data).then(res => {
          if (res.code == 0) {
            this.initUserList()
          }
        })
      },
      /*保存修改*/
      saveDistribution() {
        let data = {
          id: this.chatRelated.id,
          businessId: this.businessGroupIDs.join(','),
          top: this.numTxt,
          language: this.langIds.join(','),
          companyId:this.chatRelated.companyId
        }
        apiDeployManagement.editUser(data).then(res => {
          if (res.code == 0) {
            this.isToOftenPop = false
            this.initUserList()
          }
        })
      },
      /*初始化配置*/
      intiRule() {
        let data = {
          companyId: this.userInfo.companyId
        }
        apiDeployManagement.queryConDistributeRuleVo(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              this.ruleType = 1
              this.timeTxt = res.result.distributeTime
              this.timeType = res.result.distributeTimeUnit.toString()
              this.radioTxt = res.result.distributeType.toString()
              this.ruleID = res.result.id
            } else {
              this.ruleType = 0
            }
          }
        })
      },
      /*新增配置*/
      addRule(){
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          companyId: this.userInfo.companyId,
          distributeTime: this.timeTxt,
          distributeTimeUnit: this.timeType,
          distributeType: this.radioTxt
        }
        apiDeployManagement.addConDistributeRule(data).then(res=>{
          if (res.code==0 && res.result == true){
            this.$message.success(window.$t('im.common.addSuc'))
            this.intiRule()
          } else {
            this.$message.error(window.$t('im.common.addFail'));
          }
        })
      },
      /*修改配置*/
      updateRule() {
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          companyId: this.userInfo.companyId,
          distributeTime: this.timeTxt,
          distributeTimeUnit: this.timeType,
          distributeType: this.radioTxt,
          id: this.ruleID
        }
        apiDeployManagement.updateConDistributeRule(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.updateSuc'))
            this.intiRule()
          } else {
            this.$message.error(window.$t('im.common.updateFail'));
          }
        })
      },
      /*编辑配置*/
      editRule() {
        if (this.ruleType == 0) {
          this.addRule()
        } else if (this.ruleType == 1) this.updateRule()
      },
    },
    mounted() {
      this.initUserList()
      this.initLanguage()
      this.intiRule()
    }
  }
</script>
<style>
</style>
